import { putResolve, select, takeLatest, put } from 'typed-redux-saga/macro';
import { getAutoInvest, getAutoInvestActivity, } from '../actions/autoinvest';
import { getConnectedAccount } from '../actions';
import { selectActiveTradingAccountId } from '../reducers/selectors';
import { CANCEL_AUTOINVEST_PLAN_SUCCESS, ACCEPT_AUTOINVEST_MANDATE_SUCCESS, EDIT_AUTOINVEST_PLAN_SUCCESS, GET_AUTOINVEST_SUCCESS, } from '../actions/types';
function* refetchAutoInvestAfterMutation(_action) {
    yield* putResolve(getAutoInvest());
}
function* refetchConnectedAccountAfterMutation(_action) {
    yield* putResolve(getConnectedAccount());
}
function* refetchAutoInvestActivitiesAfterMutation() {
    const accountId = yield* select(selectActiveTradingAccountId);
    if (accountId) {
        yield* put(getAutoInvestActivity({ accountId, paging: { page: 1, perPage: 30 } }));
    }
}
function* prefetchAutoInvestActivitiesWorker(action) {
    if (action.payload.plans?.length) {
        for (const { accountId } of action.payload.plans) {
            const activities = yield* select((state) => state.unpersistedInvestReducer.autoInvestActivitiesForAccount?.[accountId]);
            if (!activities?.length) {
                yield* put(getAutoInvestActivity({ accountId, paging: { page: 1, perPage: 30 } }));
            }
        }
    }
}
function* autoinvestSaga() {
    yield* takeLatest(EDIT_AUTOINVEST_PLAN_SUCCESS, refetchAutoInvestActivitiesAfterMutation);
    yield* takeLatest(GET_AUTOINVEST_SUCCESS, prefetchAutoInvestActivitiesWorker);
    yield* takeLatest([CANCEL_AUTOINVEST_PLAN_SUCCESS, ACCEPT_AUTOINVEST_MANDATE_SUCCESS, 'GET_TRADING_ACCOUNTS_SUCCESS'], refetchAutoInvestAfterMutation);
    yield* takeLatest([ACCEPT_AUTOINVEST_MANDATE_SUCCESS, 'ACCEPT_AUTOSAVE_MANDATE_SUCCESS'], refetchConnectedAccountAfterMutation);
}
export default autoinvestSaga;
